// Sys layout-specific JavaScript
// This replaces app/assets/javascripts/sys.js

import { ready } from "../modules/core";

// Export a function that initializes the sys layout
export function initialize() {
  console.log("Sys layout initialization function called");
  
  // Initialize Select2 dropdowns
  initializeSelect2();
  
  // Initialize Charts if any exist
  initializeCharts();
  
  // Add event listeners for sidebar toggling
  document.querySelectorAll('#sidebarToggle').forEach(toggle => {
    toggle.addEventListener('click', function() {
      const sidebar = document.getElementById('adminSidebar');
      const content = document.getElementById('content-wrapper');
      
      if (sidebar) {
        sidebar.classList.toggle('tw-admin-sidebar-collapsed');
      }
      
      if (content) {
        content.classList.toggle('tw-admin-content-with-collapsed-sidebar');
      }
      
      // Toggle the icon direction
      const icon = this.querySelector('i');
      if (icon) {
        icon.classList.toggle('fa-angle-left');
        icon.classList.toggle('fa-angle-right');
      }
    });
  });
  
  // Initialize sys-specific components
  initializeSysComponents();
  
  return true;
}

// Initialize enhanced select elements - using Stimulus controller instead of Select2
function initializeSelect2() {
  console.log("Select2 functionality is now handled by the Stimulus select controller");

  // Find any legacy select2 elements that don't have a controller
  document.querySelectorAll('select.select2:not([data-controller*="select"])').forEach(select => {
    // Add the Stimulus controller to handle enhanced select functionality
    select.setAttribute('data-controller', 'select');
    select.setAttribute('data-select-placeholder-value', select.getAttribute('placeholder') || 'Select an option...');
  });
}

// Initialize Chart.js charts if they exist
function initializeCharts() {
  // Only run if Chart.js is available (loaded via CDN or other means)
  if (window.Chart) {
    // Find all canvas elements that should have charts
    document.querySelectorAll('canvas[data-chart-type]').forEach(canvas => {
      try {
        const chartType = canvas.getAttribute('data-chart-type');
        const chartData = JSON.parse(canvas.getAttribute('data-chart-data') || '{}');
        const chartOptions = JSON.parse(canvas.getAttribute('data-chart-options') || '{}');
        
        if (chartType && chartData) {
          new window.Chart(canvas, {
            type: chartType,
            data: chartData,
            options: chartOptions
          });
        }
      } catch (error) {
        console.error('Error initializing chart:', error);
      }
    });
  }
}

// Initialize sys-specific UI components
function initializeSysComponents() {
  // Add special handling for sysadmin-specific components
  
  // Entity switching functionality 
  const entitySelector = document.getElementById('entity-selector');
  if (entitySelector) {
    entitySelector.addEventListener('change', function() {
      const selectedEntityId = this.value;
      if (selectedEntityId) {
        // Navigate to the selected entity
        const form = document.getElementById('entity-switch-form');
        if (form) {
          form.submit();
        } else {
          window.location.href = `/sys/entities/${selectedEntityId}`;
        }
      }
    });
  }
  
  // Handle data table initializations if needed
  document.querySelectorAll('.sys-data-table').forEach(table => {
    // Add sorting, pagination, etc.
    if (window.$ && window.$.fn.DataTable) {
      try {
        window.$(table).DataTable({
          pageLength: 25,
          order: [[0, 'desc']]
        });
      } catch (error) {
        console.error('Error initializing data table:', error);
      }
    }
  });
}

// Also initialize on page load using the ready function
ready(() => {
  console.log("Sys layout loaded via ready function");
  
  // We don't need jQuery anymore as we're using native browser APIs and Stimulus
  // This verification is no longer needed since we have our stubs
  
  initialize();
});

// Export the module name for easier debugging
export const MODULE_NAME = 'sys';

// Default export for dynamic imports
export default {
  initialize,
  MODULE_NAME
};